<template>
  <div
    class="ws-icon v-icon v-icon--size-default"
    v-html="svgIcon"
  ></div>
</template>
<script
  setup
  lang="ts"
>
import { computed } from 'vue'
import DiscordSvg from '~~/public/discord-svgrepo-com.svg?raw';
import TelegramSvg from '~~/public/telegram-wo-color.svg?raw';

const props = defineProps<{
  icon: 'ws-icon-discord' | 'ws-icon-telegram';
  size?: string;
  color?: string;
  class?: string;
  style?: string;
  onClick?: () => void;
}>();

const svgIcon = computed(() => {
  if (props.icon === 'ws-icon-discord') {
    return DiscordSvg;
  }
  if (props.icon === 'ws-icon-telegram') {
    return TelegramSvg;
  }
  return '';
});

</script>
<style scoped>
.ws-icon {
  display: inline-block;
}

.ws-icon svg {
  max-width: 100%;
  max-height: 100%;
}
</style>
